module.exports = __webpack_public_path__ + "img/time-white.7c523dab.svg";